"use client";

import React from "react";
import { Clock, ShieldCheck, MapPin, Zap, Truck } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const benefits = [{
  title: "Optimalizované trasy",
  description: "Noční doprava se vyhýbá denním zácpám, což vede k rychlejším přepravním časům.\n",
  icon: MapPin
}];
export default function NightTransportBenefits() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="night-transport-benefits" ref={ref} className="relative w-full bg-[#0F172A] text-white overflow-hidden py-16 md:py-24 lg:py-32">
      {}
      <div className={cn("container mx-auto px-4 md:px-6 transition-all duration-1000 ease-out transform", isVisible ? "opacity-100 translate-y-0 clip-path-inset-0" : "opacity-0 translate-y-12 clip-path-inset-bottom")} style={{
      clipPath: isVisible ? "inset(0 0 0 0)" : "inset(10% 0 100% 0)"
    }}>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          
          {}
          <div className="lg:col-span-7 flex flex-col gap-12">
            <div className="space-y-4">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-white">
                Noční logistika
              </h2>
              <p className="text-lg text-slate-300 max-w-2xl leading-relaxed">
                Využijte výhodu dopravy mimo špičku. Proměníme noc ve vaši konkurenční výhodu díky specializovaným řešením pro noční přepravu.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-10">
              {benefits.map((item, i) => <div key={i} data-index={i} className="flex flex-col gap-3 group">
                  <div className="flex items-center gap-3">
                    <item.icon className="w-6 h-6 text-[hsl(190,80%,55%)] stroke-[1.5px]" aria-hidden="true" />
                    <h3 className="text-xl font-bold text-white group-hover:text-[hsl(190,80%,55%)] transition-colors duration-300">
                      {item.title}
                    </h3>
                  </div>
                  <p className="text-slate-400 text-sm leading-relaxed">
                    {item.description}
                  </p>
                </div>)}
            </div>

            {}
            
          </div>

          {}
          

        </div>
      </div>
    </section>;
}